import React, { useEffect, useRef, useState } from "react";
import PotraitCard from "../../components/PotraitCard/PotraitCard";
import SummaryCard from "../../components/SummaryCard/SummaryCard";
import "./DashBoard.css";
import Button from "../../components/Button/Button";
import Chart from "../../components/Chart/Chart";
//import { Globals } from "../../global/Globals";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import Pagination from "../../components/Pagination/Pagination";
import { fetchBriefs, ProposolsCount } from "../../services/dashboardAPI";
import {fetchByfilter } from "../../services/GenericAPI";
import NoResultsComponent from "../../components/NoResults/NoResult";
import HalfPageBreif from "../../components/HalfPage_Popup/HalfPageBrief";
import Loader from "../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Toast from "../../components/Toast/Toast";
import TermsPopup from "../../components/TermsConditions/TermsPopup";
import CryptoUtils from "../../util/cryptoUtils";
import { useLanguage } from "../../context/Languagecontext";
import FallBackLabel from '../../global/Globals_Eng.json';
let paginationPageChange = () => {};

const Dashboard = () => {
  const { Globals ,languages, setLanguages } = useLanguage();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("All");
  const [activeTimeTab, setActivetimetab] = useState("OneMonth");
  const [briefActiveTab, setBriefActiveTab] = useState("All");
  const [HalfPageData, setHalfPageData] = useState("");
  const [isHalfScreenPopupVisible, setIsHalfScreenPopupVisible] = useState(false);
  const [briefData, setBriefData] = useState([]);
  const [briefStatus, setbriefStatus] = useState(null);
  const [proposalCount, setProposalCount] = useState([]);
  const [enableClearAll, setEnableClearAll] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(false);
  const [ccDashBoard, setTitleCCDashBoard] = useState(false);
  const [isConfidentialSelected, setIsConfidentialSelected] = useState(JSON.parse(CryptoUtils.getFromLocalStorage('isConsent')));
  const [dropdownState, setDropdownState] = useState({
    activeDropdown: null,
    dropdowns: {
      CHANNEL: { options: [], selected: [], selectedText: [], isloading: false },
      COUNTRY: { options: [], selected: [], selectedText: [], isloading: false },
      TYPE: { options: [], selected: [], selectedText: [], isloading: false },
      FORMAT: { options: [], selected: [], selectedText: [], isloading: false },
      GENRE: { options: [], selected: [], selectedText: [], isloading: false },
      LANGUAGE: { options: [], selected: [], selectedText: [], isloading: false },
    },
  });

  const dropdownRefs = useRef({}); // Store refs for dropdowns

  const prevSelectedState = useRef({});
  const location = useLocation();
  const { success,draft,discard } = location.state || {};
  const [successToast, setSuccessToast] = useState({status:false,title:Globals.PROPOSAL_SUBMIT_SUCCESS});
  useEffect(() => {
      if (success) {
        if(draft){
          setSuccessToast({status:true,title:Globals.PROPOSAL_SAVE_SUCCESS});
        }else if(discard){
          setSuccessToast({status:true,title:Globals.TOAST_DISCARD_PROPOSAL_PROMPT_TITLE});
        }
        else{  
          setSuccessToast({status:true,title:Globals.PROPOSAL_SUBMIT_SUCCESS});
        }
        setTimeout(() => {
          setSuccessToast({status:false,title:""});
        }, 4000);
      }
    }, [success]);
  useEffect(() => {
    let hasChanges = false;
    const hasSelectedOptions = Object.values(dropdownState?.dropdowns).some(
      (dropdown) => dropdown?.selected && dropdown?.selected.length >= 0
    );
    const hasselectedOptions = Object.values(dropdownState.dropdowns).some(
      (dropdown) => dropdown?.selected && dropdown.selected.length > 0
    );

    if (hasselectedOptions) {
      setEnableClearAll(true);
    } else {
      setEnableClearAll(false);
    }

    Object.keys(dropdownState.dropdowns).forEach((key) => {
      const currentSelected = dropdownState.dropdowns[key]?.selected;
      const prevSelected = prevSelectedState.current[key]?.selected;

      if (JSON.stringify(currentSelected) !== JSON.stringify(prevSelected)) {
        hasChanges = true;
        if (hasSelectedOptions) {
          const data = {
            channel: dropdownState.dropdowns.CHANNEL.selected,
            country: dropdownState.dropdowns.COUNTRY.selected,
            type: dropdownState.dropdowns.TYPE.selected,
            format: dropdownState.dropdowns.FORMAT.selected,
            genre: dropdownState.dropdowns.GENRE.selected,
            language: dropdownState.dropdowns.LANGUAGE.selected,
          };
          paginationPageChange(1);
          fetchBriefdata(briefActiveTab, data, 1);
        }
      }
    });

    if (hasChanges) {
      prevSelectedState.current = { ...dropdownState.dropdowns }; // Update the reference with new selected values
    }
  }, [dropdownState]);

  useEffect(() => {
    const hasSelectedOptions = Object.values(dropdownState.dropdowns).some(
      (dropdown) => dropdown.selected.length >= 0
    );

    if (hasSelectedOptions) {
      const data = {
        channel: dropdownState.dropdowns.CHANNEL.selected,
        country: dropdownState.dropdowns.COUNTRY.selected,
        type: dropdownState.dropdowns.TYPE.selected,
        format: dropdownState.dropdowns.FORMAT.selected,
        genre: dropdownState.dropdowns.GENRE.selected,
        language: dropdownState.dropdowns.LANGUAGE.selected,
      };

      fetchBriefdata(briefActiveTab, data, 1);
    }
  }, [briefActiveTab]);

  const togglePopup = (data) => {
    setHalfPageData(data)
    setIsHalfScreenPopupVisible(!isHalfScreenPopupVisible);
  };

  useEffect(() => {
    if (isHalfScreenPopupVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isHalfScreenPopupVisible]);
  useEffect(() => {
    const data = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      country: dropdownState.dropdowns.COUNTRY.selected,
      type: dropdownState.dropdowns.TYPE.selected,
      format: dropdownState.dropdowns.FORMAT.selected,
      genre: dropdownState.dropdowns.GENRE.selected,
      language: dropdownState.dropdowns.LANGUAGE.selected,
    };

    fetchBriefdata(briefActiveTab, data, currentPage);
  }, [currentPage]);

  useEffect(() => {
    fetchBriefdata(activeTab);
    fetchPorposolsCount(activeTab, activeTimeTab);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside all dropdowns
      const isClickInsideDropdown = Object.values(dropdownRefs.current).some(
        (ref) => ref?.contains(event.target)
      );
      if (!isClickInsideDropdown) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onPageChange = (pageNumber, setPage = () => {}) => {
    setCurrentPage(pageNumber);
    paginationPageChange = setPage;
  };

  const fetchBriefdata = async (proposalType, Filters, pageNumber) => {
    try {
      const response = await fetchBriefs(proposalType, Filters, pageNumber);
      setBriefData(response.data.content);
      setbriefStatus(response.status);
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  };

  const fetchPorposolsCount = async (type, date) => {
    try {
      const response = await ProposolsCount(type, date,false);
      setProposalCount(response.data.content);
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    fetchPorposolsCount(tab, activeTimeTab);
  };

  const handleTimeTabClick = (data) => {
    setActivetimetab(data);
    fetchPorposolsCount(activeTab, data);
  };

  const handleBriefTabClick = (tab) => {
    setBriefActiveTab(tab);
    paginationPageChange(1);
  };

  const handletog = async (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));

    if (dropdownState.dropdowns[dropdownName].options.length === 0) {
      await fetchOptions(dropdownName);
    }
  };

  const fetchOptions = async (dropdownName) => {
    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: true },
      },
    }));

    try {
      const response = await fetchByfilter(
        FallBackLabel.FILTER_OPTIONS_NAME[dropdownName]
      );
      const data = response.data.content;
      const filterData = data[FallBackLabel.FILTER_OPTIONS_NAME[dropdownName]];
      // Simulate fetching options for each dropdown
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...prev.dropdowns[dropdownName],
            options: [...filterData],
            isLoading: false,
          },
        },
      }));
    } catch (error) {
      console.error("Error fetching options:", error);
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: false },
        },
      }));
    }
  };

  const handleSelectAll = (dropdownName, selectAll, options) => {
    setbriefStatus(null);
    const selectedDataString = options.map((option) => String(option.id));
    const selectedDataText = options.map((option) => String(option.name));

    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: {
          ...prev.dropdowns[dropdownName],
          selected: selectAll ? selectedDataString : [],
          selectedText: selectAll ? selectedDataText : [],
        },
      },
    }));
  };

  const handleSelect = (dropdownName, value) => {
    setbriefStatus(null);
    setDropdownState((prev) => {
      const dropdown = prev.dropdowns[dropdownName];
      if (!dropdown) return prev;

      const isSelected = dropdown.selected.includes(String(value.id));
      const inSelectedText = dropdown.selectedText.includes(String(value.name));

      const newSelected = isSelected
        ? dropdown.selected
            .filter((item) => item !== String(value.id))
            .map(String)
        : [
            ...dropdown.selected.filter((item) => item !== String(value.id)),
            String(value.id),
          ];

      const newSelectedText = inSelectedText
        ? dropdown.selectedText.filter((item) => item !== String(value.name)).map(String)
        : [
            ...dropdown.selectedText.filter((item) => item !== String(value.name)),
            String(value.name),
          ];

      return {
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...dropdown,
            selected: newSelected,
            selectedText: newSelectedText,
          },
        },
      };
    });
  };

  const handleClearAll = () => {
    if (enableClearAll) {
      setbriefStatus(null);
      setCurrentPage(1);
      setEnableClearAll(false);
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [] };
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
    }
  };
 
  const dropdownselected = Object.values(dropdownState?.dropdowns).some(
    (dropdown) => dropdown?.selected && dropdown?.selected.length > 0
  );

  useEffect(() => {
    console.log("languageschanged",languages);
   setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [], options:[] };
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
      console.log("languageschanged",dropdownState);

      const data = {
        channel: dropdownState.dropdowns.CHANNEL.selected,
        country: dropdownState.dropdowns.COUNTRY.selected,
        type: dropdownState.dropdowns.TYPE.selected,
        format: dropdownState.dropdowns.FORMAT.selected,
        genre: dropdownState.dropdowns.GENRE.selected,
        language: dropdownState.dropdowns.LANGUAGE.selected,
      };

      fetchBriefdata(briefActiveTab, data, 1);
      
  }, [languages]); 

  return (
    <>
    <div className="dashboard">
      <div className="dashboard-top">
        <div className="dashboard-heading">{Globals.PRODUCER.DASHBOARD}</div>
        <Button
          action={() => {
            navigate(Globals.NAVPATH.CREATE_UNSOLICITED, { state: { activeHeader: "dashboard" } });
          }}
          title={ccDashBoard ? Globals.PRODUCER.NEWBRIEF : Globals.PRODUCER.UNSOLICITEDPROPOSAL}
          additionalStyle={ccDashBoard ? "new-proposal" : "unsolicited-proposal"}
          id={ccDashBoard ? "Create_New_Brief" : "Create_Unsolicited_Proposal"}
        />
      </div>

      <div className="dashboard-overview">
          <div className="current-opportunities">
            <Chart open={briefData?.openBriefs} closed={briefData?.closedBriefs} />
          </div>
      
        <div className="proposal-overview">
          <div className="proposals-heading">
            <span>{ccDashBoard ? Globals.PRODUCER.ALLPROPOSALS : Globals.PRODUCER.MYPROPOSALS}</span>
          </div>

          <div className="proposal-overview-tabs">
            <div className="active-inactive-tabs">
              <div
                className={`proposal-overview-tab ${
                  activeTab === "All" ? "active" : ""
                }`}
                onClick={() => handleTabClick("All")}
              >
                {Globals.DASHBOARD.ALL}
              </div>
              <div
                className={`proposal-overview-tab ${
                  activeTab === "Solicited" ? "active" : ""
                }`}
                onClick={() => handleTabClick("Solicited")}
              >
                {Globals.DASHBOARD.SOLICITED}
              </div>
              <div
                className={`proposal-overview-tab ${
                  activeTab === "Unsolicited" ? "active" : ""
                }`}
                onClick={() => handleTabClick("Unsolicited")}
              >
                {Globals.DASHBOARD.UNSOLICITED}
              </div>
            </div>
            <div className="date-timetabs">
              <div
                className={`date-overview-tab ${
                  activeTimeTab === "OneMonth" ? "active" : ""
                }`}
                onClick={() => handleTimeTabClick("OneMonth")}
              >
                {Globals.DASHBOARD.ONEMONTH}
              </div>
              <div
                className={`date-overview-tab ${
                  activeTimeTab === "SixMonths" ? "active" : ""
                }`}
                onClick={() => handleTimeTabClick("SixMonths")}
              >
                {Globals.DASHBOARD.SIXMONTHS}
              </div>
              <div
                className={`date-overview-tab ${
                  activeTimeTab === "OneYear" ? "active" : ""
                }`}
                onClick={() => handleTimeTabClick("OneYear")}
              >
                {Globals.DASHBOARD.ONEYEAR}
              </div>
              <div
                className={`date-overview-tab ${
                  activeTimeTab === "All" ? "active" : ""
                }`}
                onClick={() => handleTimeTabClick("All")}
              >
                {Globals.DASHBOARD.GREATERTHANONEYEAR}
              </div>
            </div>
          </div>
          <div className="summary-cards">
            {proposalCount && proposalCount.length > 0
              ? proposalCount?.map((item) => (
                  <>
                    {Object.keys(item).map((key) => (
                      <SummaryCard
                        key={`${item.id}-${key}`} // Ensuring the key is unique
                        title={key}
                        count={item[key]}
                        submissionType
                      />
                    ))}
                  </>
                ))
              : briefStatus &&
                briefStatus.length > 0 && (
                  <div className="no-data">
                    <NoResultsComponent
                      data={{
                        message: Globals.NO_RESULTS_MESSAGE,
                        img: Globals.NO_RESULTS_IMG,
                        submessage: Globals.NO_RESULTS_DASHBOARD_MESSAGE,
                      }}
                    />
                  </div>
                )}
          </div>
        </div>
      </div>

      <div className="dashboard-brief">
        <div className="dashboard-breif_heading">{Globals.PRODUCER.ACTIVEBRIEF}</div>
        <div className="dashboard-brief-tabs">
          <div
            className={`dashboard-brief-tab ${
              briefActiveTab === "All" ? "active" : ""
            }`}
            onClick={() => handleBriefTabClick("All")}
          >
            {Globals.DASHBOARD.ALL}
          </div>
          <div
            className={`dashboard-brief-tab ${
              briefActiveTab === "Open" ? "active" : ""
            }`}
            onClick={() => handleBriefTabClick("Open")}
          >
            {Globals.DASHBOARD.OPEN}
          </div>
          <div
            className={`dashboard-brief-tab ${
              briefActiveTab === "Invited" ? "active" : ""
            }`}
            onClick={() => handleBriefTabClick("Invited")}
          >
            {Globals.DASHBOARD.CLOSED}
          </div>
        </div>

        <div className="filters">
          <div className="results">{briefData?.totalPageCount} {Globals.PRODUCER.BRIEFS}</div>
          <div className="row_spearator"></div>
          <div className="filterHeading">{Globals.PRODUCER.FILTERBY}</div>

          <CheckboxDropDown
            isOpen={activeDropdown === "CHANNEL"}
            options={dropdownState.dropdowns.CHANNEL.options}
            onToggle={() => handletog("CHANNEL")}
            onSelectAll={(selectAll, options) =>
              handleSelectAll("CHANNEL", selectAll, options)
            }
            onSelect={(value) => {
              handleSelect("CHANNEL", value);
            }}
            selectedValues={dropdownState.dropdowns.CHANNEL.selected}
            title={Globals.FILTER.CHANNEL}
            isDatePicker={false}
            dropdownRef={(el) => (dropdownRefs.current["Channel"] = el)}
            selectedItems={dropdownState.dropdowns.CHANNEL.selectedText}
          />
          <CheckboxDropDown
            isOpen={activeDropdown === "COUNTRY"}
            options={dropdownState.dropdowns.COUNTRY.options}
            onToggle={() => handletog("COUNTRY")}
            onSelectAll={(selectAll, options) =>
              handleSelectAll("COUNTRY", selectAll, options)
            }
            onSelect={(value) => handleSelect("COUNTRY", value)}
            title={Globals.FILTER.COUNTRY}
            isDatePicker={false}
            selectedValues={dropdownState.dropdowns.COUNTRY.selected}
            dropdownRef={(el) => (dropdownRefs.current["Country"] = el)}
            selectedItems={dropdownState.dropdowns.COUNTRY.selectedText}
          />
          <CheckboxDropDown
            isOpen={activeDropdown === "TYPE"}
            options={dropdownState.dropdowns.TYPE.options}
            onToggle={() => handletog("TYPE")}
            onSelectAll={(selectAll, options) =>
              handleSelectAll("TYPE", selectAll, options)
            }
            onSelect={(value) => handleSelect("TYPE", value)}
            selectedValues={dropdownState.dropdowns.TYPE.selected}
            title={Globals.FILTER.TYPE}
            isDatePicker={false}
            dropdownRef={(el) => (dropdownRefs.current["Type"] = el)}
            selectedItems={dropdownState.dropdowns.TYPE.selectedText}
          />
          <CheckboxDropDown
            isOpen={activeDropdown === "FORMAT"}
            options={dropdownState.dropdowns.FORMAT.options}
            onToggle={() => handletog("FORMAT")}
            onSelectAll={(selectAll, options) =>
              handleSelectAll("FORMAT", selectAll, options)
            }
            onSelect={(value) => handleSelect("FORMAT", value)}
            title={Globals.FILTER.FORMAT}
            isDatePicker={false}
            selectedValues={dropdownState.dropdowns.FORMAT.selected}
            dropdownRef={(el) => (dropdownRefs.current["Format"] = el)}
            selectedItems={dropdownState.dropdowns.FORMAT.selectedText}
          />
          <CheckboxDropDown
            isOpen={activeDropdown === "GENRE"}
            options={dropdownState.dropdowns.GENRE.options}
            onToggle={() => handletog("GENRE")}
            onSelectAll={(selectAll, options) =>
              handleSelectAll("GENRE", selectAll, options)
            }
            onSelect={(value) => handleSelect("GENRE", value)}
            title={Globals.FILTER.GENRE}
            isDatePicker={false}
            selectedValues={dropdownState.dropdowns.GENRE.selected}
            dropdownRef={(el) => (dropdownRefs.current["Genre"] = el)}
            selectedItems={dropdownState.dropdowns.GENRE.selectedText}
          />
          <CheckboxDropDown
            isOpen={activeDropdown === "LANGUAGE"}
            options={dropdownState.dropdowns.LANGUAGE.options}
            onToggle={() => handletog("LANGUAGE")}
            onSelectAll={(selectAll, options) =>
              handleSelectAll("LANGUAGE", selectAll, options)
            }
            onSelect={(value) => handleSelect("LANGUAGE", value)}
            selectedValues={dropdownState.dropdowns.LANGUAGE.selected}
            title={Globals.FILTER.LANGUAGE}
            isDatePicker={false}
            dropdownRef={(el) => (dropdownRefs.current["Language"] = el)}
            selectedItems={dropdownState.dropdowns.LANGUAGE.selectedText}
          />

          <div
            className={enableClearAll ? "clear clearAllEnable" : "clear"}
            onClick={() => handleClearAll()}
          >
           {Globals.PRODUCER.CLEARALL}
          </div>
        </div>
        {isHalfScreenPopupVisible && (
          <div className="popup">
            <HalfPageBreif additionalData={HalfPageData} togglePopup={togglePopup} />
          </div>
        )}
        <div className="cards-container">
          {briefData?.briefs && briefData?.briefs.length > 0 ? (
            briefData?.briefs?.map((card, index) => (
              <PotraitCard key={index} data={card} togglePopup={togglePopup} />
            ))
          ) : briefStatus ? (
            <div className="no-data">
              <NoResultsComponent
                data={{
                  message: dropdownselected
                    ? Globals.NO_RESULTS_MESSAGE
                    : Globals.NO_DATA_WITHOUTFILTER,
                  img: dropdownselected ? FallBackLabel.NO_RESULTS_IMG : FallBackLabel.NO_DATA_FOUND_IMG,
                  submessage: dropdownselected ? Globals.NO_RESULTS_DASHBOARD_MESSAGE : "",
                }}
              />
            </div>
          ) : (
            <Loader height={50} width={50} component={"Dashboard"} />
          )}
        </div>

        <div className="pagination-container">
          {briefData?.briefs && briefData?.briefs.length > 0 && (
            <Pagination
              totalPages={Math.ceil(
                briefData?.totalPageCount / Globals.MAX_COUNT.ACTIVE_BRIEF_COUNT
              )}
              currentPage={currentPage}
              onPageChange={onPageChange}
            />
          )}
        </div>
      </div>
    </div>
    {successToast?.status && <Toast status="success" onClose={()=>{setSuccessToast(false);}} title={successToast.title} />}
      {(isConfidentialSelected===false)&&<TermsPopup/>}
    </>
    
  );
};

export default Dashboard;
